(function() {
    'use strict';

    const STORAGE_KEY = 'of_home_version';
    module.exports = {
        setOFHomeVersionInSessionStorage: () => Odigeo.Session.set(STORAGE_KEY, Odigeo.SessionScope.oneFrontHomeVersion),
        setOFHomeVersionInLocalStorage: function() {
            var regex = /^(?:.)+\.([0-9]+)(?:.)+$/;
            var releaseNumber = regex.exec(Odigeo.SessionScope.oneFrontHomeVersion);
            if (!Odigeo.Storage.get(STORAGE_KEY)) {
                Odigeo.Storage.set(STORAGE_KEY, _.isArray(releaseNumber) && releaseNumber.length > 0 ?
                    releaseNumber[1] : Odigeo.SessionScope.oneFrontHomeVersion);
            }
        },
        removeFromStorage: function(storeType, storeField) {
            Odigeo[storeType].remove(storeField);
        },
    };
}());
